import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setMe } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const match = window.location.hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    window.history.replaceState(null, "", window.location.pathname);
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    api.post("/auth/session", { session_id: sessionId })
      .then((r) => { setMe(r.data); navigate("/app", { replace: true, state: { user: r.data } }); })
      .catch(() => navigate("/login", { replace: true }));
  }, [navigate, setMe]);

  return <div className="min-h-screen bg-[#080D1A]" />;
}
